export enum ERubricAttribute {
    API_URL = 'data-api-url',
    SKELETON_NAME = 'data-rubric-skeleton-name',
}
